var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-page"},[_c('div',{staticClass:"skeleton-header"},[_c('div',{staticClass:"header-content"},[_c('skeleton-loading',{staticClass:"skeleton-wrapper wrapper"},[_c('row',[_c('column',{attrs:{"span":0,"gutter":0}},[_c('square-skeleton',{staticClass:"detail-content-skeleton",attrs:{"box-properties":{
                bottom: '30px',
                width: '340px',
                height: '45px',
                top:'60px'
              }}})],1)],1),_vm._v(" "),_c('div',{staticClass:"detail-skeleton-content"},[_c('div',{staticClass:"skeleton-left"},[_c('square-skeleton',{staticClass:"detail-content-skeleton",attrs:{"box-properties":{
                bottom: '60px',
                width: '560px',
                height: '420px',

              }}})],1),_vm._v(" "),_c('div',{staticClass:"skeleton-right"},[_c('skeleton-loading',{staticClass:"skeleton-wrapper wrapper"},[_c('square-skeleton',{attrs:{"box-properties":{
                  height: '36px',
                  bottom:'20px',
                  width: '250px',
                }}}),_vm._v(" "),_c('square-skeleton',{attrs:{"box-properties":{
                  width: '134px',
                  height: '24px',
                  bottom:'4px'
                }}}),_vm._v(" "),_c('square-skeleton',{attrs:{"box-properties":{
                  height: '24px',
                  bottom:'20px',
                  width: '230px',
                }}}),_vm._v(" "),_c('square-skeleton',{attrs:{"box-properties":{
                  width: '140px',
                  height: '24px',
                  bottom:'4px'
                }}}),_vm._v(" "),_c('square-skeleton',{attrs:{"box-properties":{
                  height: '24px',
                  bottom:'89px',
                  width: '230px',
                }}}),_vm._v(" "),_c('square-skeleton',{attrs:{"box-properties":{
                  width: '360px',
                  height: '151px',
                }}})],1)],1)])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"skeleton-body"},[_c('skeleton-loading',{staticClass:"skeleton-wrapper wrapper"},[_c('square-skeleton',{attrs:{"box-properties":{
          height: '91px',
          bottom:'50px'
        }}}),_vm._v(" "),_c('square-skeleton',{attrs:{"box-properties":{
          height: '36px',
          width: '300px',
          bottom: '20px'
        }}}),_vm._v(" "),_c('square-skeleton',{attrs:{"box-properties":{
          height: '488px',
        }}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }